import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { LoginService } from './layout/login/login.service';
import { ColorService } from './shared/services/color.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    private readonly restService: MxBaseRestService,
    private readonly alertService: MxAlertService,
    private authService: LoginService,
    private colorService: ColorService
  ) {}

  ngOnInit(): void {
    this.accessControl();
    this.colorService.getColor("MAIN").then(response => {
      sessionStorage.setItem("colorMain", response.code)
    }).catch(e => console.log(e))
  }

  async accessControl() {
    if (localStorage.getItem('token')) {
      const accessControl = await this.restService
        .getter('access-control', '', '')
        .toPromise();

      accessControl &&
        this.bnIdle
          .startWatching(accessControl.timeout * 60)
          .subscribe((isTimedOut: boolean) => {
            this.alertService.warning('Logout automático, sua sessão expirou');
            this.router.navigate(['/logout']);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            this.authService.usuarioAutenticado = false;
            this.authService.mostrarMenuEmitter.emit(false);
            this.authService.usuario = null;
            this.router.navigate(['/login']);
          });
    }
  }
}
